import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const timerecordTeamDataClassName = DataClassName.TIMERECORD_TEAM
const timerecordTeamEndpoint = PisaDataClassEndpoint.TIMERECORD_TEAM

export function pisaTimerecordTeamDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(timerecordTeamDataClassName, {
    title: timerecordTeamDataClassName,
    restApi: createPisaRestApiConfig(timerecordTeamEndpoint),
    attributes,
  })
}
